import React from "react";
import { Container, Typography, Box } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Box display="flex"  justifyContent="flex-start" mb={4}>
        <img
          src={'https://www.connectoverseas.com/images/logo.png'} // change to your logo path if different
          alt="Visa Info - Connect Overseas Logo"
          style={{ width: 180, height: "auto" }}
        />
      </Box>
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>

      <Typography variant="body1" paragraph>
        At <strong>Visa Info - Connect Overseas</strong>, your privacy is our top priority. This
        Privacy Policy outlines how we collect, use, and safeguard your personal
        data when you use our mobile app. By using our services, you agree to
        the terms outlined below.
      </Typography>

      <Typography variant="h6" gutterBottom>
        1. Information We Collect
      </Typography>
      <Typography variant="body1" paragraph>
        We collect personal information that you provide directly to us,
        including:
        <ul>
          <li>Full name, email address, and contact number</li>
          <li>Profile and account-related information</li>
          <li>Messages exchanged through the app</li>
          <li>Audio and video call metadata (not the content)</li>
          <li>Device and usage data for improving performance</li>
        </ul>
      </Typography>

      <Typography variant="h6" gutterBottom>
        2. How We Use Your Data
      </Typography>
      <Typography variant="body1" paragraph>
        We use the information to:
        <ul>
          <li>Facilitate visa consultations and communication between users and counsellors</li>
          <li>Provide chat, video call, voice call, and live stream services</li>
          <li>Enhance user experience and app performance</li>
          <li>Ensure security, detect fraud, and prevent abuse</li>
          <li>Respond to support inquiries and feedback</li>
        </ul>
      </Typography>

      <Typography variant="h6" gutterBottom>
        3. Data Sharing and Selling
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Visa Info - Connect Overseas does not sell, rent, or share your data</strong> with
        third-party advertisers or external agencies. All personal data is used
        exclusively for delivering our services and improving the app
        experience.
      </Typography>

      <Typography variant="h6" gutterBottom>
        4. Security Measures
      </Typography>
      <Typography variant="body1" paragraph>
        We use industry-standard encryption, secure storage, and access controls
        to protect your data. Real-time features such as chat, voice, and video
        communication are secured using encrypted channels to ensure privacy
        and confidentiality.
      </Typography>

      <Typography variant="h6" gutterBottom>
        5. Your Rights
      </Typography>
      <Typography variant="body1" paragraph>
        You have the right to:
        <ul>
          <li>Access your personal data</li>
          <li>Request correction or deletion</li>
          <li>Withdraw consent at any time</li>
        </ul>
        You can exercise these rights through the app or by contacting our support team.
      </Typography>

      <Typography variant="h6" gutterBottom>
        6. Data Retention
      </Typography>
      <Typography variant="body1" paragraph>
        We retain your information only as long as necessary for the purpose it
        was collected. Chat and call logs are not stored beyond the required
        duration unless specifically needed for legal or service-related reasons.
      </Typography>

      <Typography variant="h6" gutterBottom>
        7. Compliance with Regulations
      </Typography>
      <Typography variant="body1" paragraph>
        Our app complies with international privacy standards including:
        <ul>
          <li>General Data Protection Regulation (GDPR)</li>
          <li>Information Technology Act (India)</li>
          <li>Other applicable data privacy laws</li>
        </ul>
      </Typography>

      <Typography variant="h6" gutterBottom>
        8. Updates to This Policy
      </Typography>
      <Typography variant="body1" paragraph>
        We may update this Privacy Policy from time to time to reflect changes
        in our practices or legal obligations. Updates will be published in the
        app and on our official website.
      </Typography>

      <Typography variant="h6" gutterBottom>
        9. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions or concerns regarding this policy or your
        data, please contact us at:
        <br />
        <strong>Email:</strong> enquiry@connectoverseas.com
        <br />
        <strong>Phone:</strong>  +91 70878 33735
      </Typography>

      <Typography variant="body2" color="textSecondary" mt={4}>
        Last updated: {new Date().toLocaleDateString()}
      </Typography>
    </Container>
  );
};

export default PrivacyPolicy;
